import { render, staticRenderFns } from "./sidepanel-action-bar.vue?vue&type=template&id=63bb7f86"
import script from "./sidepanel-action-bar.vue?vue&type=script&lang=js"
export * from "./sidepanel-action-bar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports